/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-21 10:33:46
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 15:12:21
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\stores\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ref, computed, onMounted } from 'vue';

import { defineStore } from 'pinia';

import { CascaderProps } from 'ant-design-vue';

import {dbUtils} from 'xmgoing-utils';

import {defHttp, getSystemConfigObj} from 'xmgoing-server';
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import GoingUtils from '@/utils/goingUtils';

type Agent = {
  value: string;
  label: string;
  title: string;
  children?: Agent[];
};

export function listToSelItem(list) {
  return list.map((itemDb) => {
    const { tenantId, tenantName, childTenantIndustryType }=itemDb;
    if(itemDb.userData==null){
      itemDb.userData={};
    }
    return {
      ...itemDb.userData,
      value: tenantId,
      label: tenantName,
      title: tenantName,
      children: childTenantIndustryType.map(
        ({ tenantId: subTenantId, tenantName: subTenantName }) => {
          return {
            value: subTenantId,
            label: subTenantName,
            title: `${tenantName} / ${subTenantName}`,
          };
        },
      ),
    };
  });
}

export const useXmAgentAndIndustryToggleStore = defineStore('xm-tenant-and-industry-toggle', () => {
  const tenantList = ref<Agent[]>([]);

  const tenantIdList = ref<string[]>([]);
  const loading = ref(false);
  const CascaderRef = ref();

  const cascaderProps = computed<CascaderProps>(() => {
    return {
      loading: loading.value,
      options: tenantList.value,
    };
  });

  const isMultiple = computed(() => {
    let flag = false;

    if (tenantList.value.length > 1) {
      flag = true;
    } else {
      const index = tenantList.value.findIndex(({ children }) => {
        if (!children?.length) {
          return false;
        }
        return children?.length > 1;
      });

      flag = index > -1;
    }
    return flag;
  });

  const onChange: CascaderProps['onChange'] = (value) => {
    tenantIdList.value = value as string[];
  };

  /**
   * 获取主体切换列表
   */
  async function loadZhutiList() {
    try {
      const list = await defHttp.get({
        url: '/pe-portal/users/listByMerchant',
        params: {},
      });
      if (tenantList.value && unref(tenantList).length > 0) {
        tenantList.value = [...tenantList.value, ...listToSelItem(list)];
      } else {
        tenantList.value = listToSelItem(list);
      }
    } finally {
      loading.value = false;
    }
  }

  async function getTenantList() {
    let userInfo = dbUtils.getCachUser();
    if (userInfo) {
      const account = userInfo.account;
      //根据配置来显示 是否切换商户帐套
      const { accountSwitch, zhutiSwitch } = getSystemConfigObj();
      loading.value = true;
      //如果可以租户其切换
      if (GoingNewUtils.parseBoolean(accountSwitch)) {
        try {
          const list = await defHttp.get({
            url: '/pe-portal/users/getTenantByAccountList',
            params: {
              account,
            },
          });
          tenantList.value = listToSelItem(list);
        } finally {
          loading.value = false;
        }
      }
      //如果是开启的主体切换
      if (GoingNewUtils.parseBoolean(zhutiSwitch)) {
        //  如果不可以租户切换 而是 主体切换
        loadZhutiList();
      }
    }
  }

  onMounted(getTenantList);

  return {
    cascaderProps,
    onChange,
    CascaderRef,
    tenantList,
    isMultiple,
  };
});
